const endpoints = {
  GET_CITY: "/city",
  GET_LANGUAGES: "/languages",
  GET_PICK_POINTS: "/cityLocations",
  GET_HOURS: "/hours",
  GET_CATEGORIES: "/cityCategory",
  GET_PRE_TRIPS: "getAllTrips",
  GET_PLAN_TRIPS: "planLocations",
  GET_STATIC_CONTENT: "staticConstant",
  GET_MOBILE_OTP: "mobileOtp",
  GET_RESEND_OTP: "resendMobileOtp",
  CREATE_ORDER: "createOrder",
  GET_GENERATED_TRIP: "generateTrip",
  GET_BLOGS: "https://aaoghumen.com/dev3/api/v2/blogs",
    GET_BLOG_DETAIL: "https://aaoghumen.com/dev3/api/v2/blogDetail",
};

export default endpoints;
